import { connect } from 'react-redux';
import { getSecuredCutting, getSecuredLiveArchiveCutting } from 'store/video/cutting/selectors';
import ClipCard from './ClipCard';

const mapStateToProps = (state, props) => ({
    transcoding: getSecuredCutting(state, props),
    liveArchiveTranscoding: getSecuredLiveArchiveCutting(state, props),
});

export default connect(mapStateToProps)(ClipCard);
